import { client } from "@/lib/api/client";
import type { components } from "@/lib/api/schema";

export type MasterType = components["schemas"]["MasterTypeOut"];
export type MasterTypePage = components["schemas"]["MasterTypePage"];

export interface ListParams {
  cursor?: string | undefined;
  limit?: number | undefined;
  locale?: string | undefined;
}

export function listMasterTypes(params: ListParams = {}): Promise<MasterTypePage> {
  return client.request<MasterTypePage>("/api/v1/master-types", {
    query: { cursor: params.cursor, limit: params.limit, locale: params.locale },
  });
}

/**
 * Every master type this tenant defines, as one list.
 *
 * A registry is tens of rows, not thousands — it is the list of *kinds*
 * of master data, and a tenant with 200 of them has a modelling problem
 * rather than a pagination one. Callers that need to resolve a
 * `master_type_id` back to a code (the hierarchy browser crosses types,
 * so its nodes arrive identified by id) need the whole set, and looping
 * over cursors to build a lookup table would be worse than saying this
 * out loud.
 */
export function listAllMasterTypes(locale?: string): Promise<MasterTypePage> {
  return listMasterTypes({ limit: 200, locale });
}
